export default __webpack_public_path__ + "static/media/ukrainego-screenshot-03.d6113efe.png";